"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uploadError = _interopRequireDefault(require("./upload-error"));

var _httpResult = _interopRequireDefault(require("./http-result"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Represents the results of an individual file part upload. These results contain information such as
 * the amount of time it took to transfer, and any error that may have occurred.
 */
var PartUploadResult = /*#__PURE__*/function (_HttpResult) {
  _inherits(PartUploadResult, _HttpResult);

  var _super = _createSuper(PartUploadResult);

  /**
   * Constructs a new instance using the provided information. Can then be used to provide additional details
   * as needed.
   *
   * @param {object} options Options as provided when the upload instance was instantiated.
   * @param {DirectBinaryUploadOptions} uploadOptions Options as provided when the upload was initiated.
   * @param {InitResponseFilePart} filePart The part on which the results are based.
   */
  function PartUploadResult(options, uploadOptions, filePart) {
    var _this;

    _classCallCheck(this, PartUploadResult);

    _this = _super.call(this, options, uploadOptions);
    _this.filePart = filePart;
    _this.elapsedTime = 0;
    return _this;
  }
  /**
   * Retrieves the byte offset, inclusive, of where in the file this part begins.
   *
   * @returns {number} A file byte offset.
   */


  _createClass(PartUploadResult, [{
    key: "getStartOffset",
    value: function getStartOffset() {
      return this.filePart.getStartOffset();
    }
    /**
     * Retrieves the byte offset, exclusive, of where in the file this part ends.
     *
     * @returns {number} A file byte offset.
     */

  }, {
    key: "getEndOffset",
    value: function getEndOffset() {
      return this.filePart.getEndOffset();
    }
    /**
     * Retrieves the URL to which this file part was uploaded.
     *
     * @returns {string} A URL.
     */

  }, {
    key: "getUrl",
    value: function getUrl() {
      return this.filePart.getUrl();
    }
    /**
     * Retrieves the amount of time, in milliseconds, it took for the part to upload.
     *
     * @returns {number} Time span in milliseconds.
     */

  }, {
    key: "getUploadTime",
    value: function getUploadTime() {
      return this.elapsedTime;
    }
    /**
     * Sets the amount of time, in milliseconds, it took for the part to upload.
     *
     * @param {number} elapsedTime Time span in milliseconds.
     */

  }, {
    key: "setUploadTime",
    value: function setUploadTime(elapsedTime) {
      this.elapsedTime = elapsedTime;
    }
    /**
     * Retrieves a value indicating whether or not the part uploaded successfully.
     *
     * @returns {boolean} TRUE if the upload succeeded, FALSE otherwise.
     */

  }, {
    key: "isSuccessful",
    value: function isSuccessful() {
      return !this.getError();
    }
    /**
     * Sets the error that occurred while the part was uploading.
     *
     * @param {*} error Error object, which will be wrapped in an UploadError instance.
     */

  }, {
    key: "setError",
    value: function setError(error) {
      this.error = _uploadError.default.fromError(error, "unable to upload '".concat(this.filePart.getFileName(), "' part ").concat(this.getStartOffset(), "-").concat(this.getEndOffset(), " to signed URL"));
    }
    /**
     * Retrieves the error that occurred during the transfer. Will be falsy if there was no error.
     *
     * @returns {UploadError} Error information.
     */

  }, {
    key: "getError",
    value: function getError() {
      return this.error;
    }
    /**
     * Converts the result instance into a simple object containing all result data.
     *
     * @returns {object} Result data in a simple format.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return _objectSpread({
        start: this.getStartOffset(),
        end: this.getEndOffset(),
        message: this.getError() ? this.getError().getMessage() : '',
        elapsedTime: this.getUploadTime()
      }, _get(_getPrototypeOf(PartUploadResult.prototype), "toJSON", this).call(this));
    }
  }]);

  return PartUploadResult;
}(_httpResult.default);

exports.default = PartUploadResult;